import { Select } from "@radix-ui/themes";
import { useI18n, type TranslationKey } from "@/i18n";
import { currencyDisplayName } from "@/lib/format";
import { isCurrencySeries, type SeriesInfo } from "@/types";

interface SeriesSelectProps {
  series: SeriesInfo[];
  value: string;
  onChange: (seriesId: string) => void;
}

function seriesLabel(series: SeriesInfo, locale: "sv" | "en" | "fi", t: (key: TranslationKey) => string): string {
  if (isCurrencySeries(series)) {
    return `${series.iso} — ${currencyDisplayName(series.iso, locale)}`;
  }
  return t(`series.${series.translationKey}` as TranslationKey);
}

export function SeriesSelect({ series, value, onChange }: SeriesSelectProps) {
  const { t, locale } = useI18n();

  return (
    <Select.Root value={value} onValueChange={onChange}>
      <Select.Trigger aria-label={t("picker.series")} variant="surface" style={{ minWidth: 220 }} />
      <Select.Content>
        {series.map((s) => (
          <Select.Item key={s.id} value={s.id}>
            {seriesLabel(s, locale, t)}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
}
